import { render } from "./PurchaseNakshatraInfluenceReport.vue?vue&type=template&id=2c26e463&scoped=true"
import script from "./PurchaseNakshatraInfluenceReport.vue?vue&type=script&lang=js"
export * from "./PurchaseNakshatraInfluenceReport.vue?vue&type=script&lang=js"

import "./PurchaseNakshatraInfluenceReport.vue?vue&type=style&index=0&id=2c26e463&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c26e463"]])

export default __exports__